<template>
  <b-modal
    :visible="visible"
    title="Установить статус участника"
    size="md"
    @ok="handleSave"
    @hidden="$emit('close')"
  >
    <div v-if="participant" class="participant-info mb-4">
      <h5>{{ getParticipantName() }}</h5>
      <div class="participant-badges">
        <b-badge variant="primary" class="mr-2">#{{ participant.num }}</b-badge>
        <b-badge v-if="participant.distance" variant="info" class="mr-2">
          {{ participant.distance }}
        </b-badge>
        <b-badge v-if="participant.group" variant="secondary">
          {{ participant.group }}
        </b-badge>
      </div>
    </div>

    <b-form-group label="Статус участника">
      <b-form-radio-group v-model="selectedStatus" stacked name="status-selector">
        <b-form-radio value="finished" class="mb-3">
          <div class="status-option">
            <span class="status-icon">✅</span>
            <div>
              <strong>Финишировал</strong>
              <small class="text-muted d-block">Участник успешно завершил дистанцию</small>
            </div>
          </div>
        </b-form-radio>

        <b-form-radio value="dnf" class="mb-3">
          <div class="status-option">
            <span class="status-icon">🚫</span>
            <div>
              <strong>НФ - Не финишировал</strong>
              <small class="text-muted d-block">
                Участник стартовал, но не закончил дистанцию
              </small>
            </div>
          </div>
        </b-form-radio>

        <b-form-radio value="dsq" class="mb-3">
          <div class="status-option">
            <span class="status-icon">⛔</span>
            <div>
              <strong>ДСК - Дисквалификация</strong>
              <small class="text-muted d-block">
                Нарушение правил соревнований
              </small>
            </div>
          </div>
        </b-form-radio>

        <b-form-radio value="dns">
          <div class="status-option">
            <span class="status-icon">❌</span>
            <div>
              <strong>НС - Не стартовал</strong>
              <small class="text-muted d-block">
                Зарегистрирован, но не вышел на старт
              </small>
            </div>
          </div>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <b-alert v-if="selectedStatus !== 'finished'" variant="warning" show>
      <strong>Внимание:</strong> Участник будет перемещен в конец списка результатов
    </b-alert>
  </b-modal>
</template>

<script>
import { BModal, BFormGroup, BFormRadioGroup, BFormRadio, BBadge, BAlert } from 'bootstrap-vue'

export default {
  name: 'StatusSelector',
  components: {
    BModal,
    BFormGroup,
    BFormRadioGroup,
    BFormRadio,
    BBadge,
    BAlert,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    participant: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedStatus: 'finished',
    }
  },
  watch: {
    participant: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.status) {
          this.selectedStatus = newVal.status
        } else {
          this.selectedStatus = 'finished'
        }
      },
    },
  },
  methods: {
    getParticipantName() {
      if (!this.participant) return ''
      
      const name = this.participant.name || ''
      const secondName = this.participant.secondName || ''
      
      return secondName && name ? secondName + ' ' + name : name || secondName || 'Участник'
    },

    handleSave() {
      if (this.participant) {
        this.$emit('save', {
          userId: this.participant.userId,
          status: this.selectedStatus,
        })
      }
    },
  },
}
</script>

<style scoped>
.participant-info {
  padding: 1.143rem;
  background: #f8f8f8;
  border-radius: 0.428rem;
  border: 1px solid #ebe9f1;
}

.participant-info h5 {
  color: #5e5873;
  font-weight: 600;
  margin-bottom: 0.571rem;
}

.participant-badges {
  margin-top: 0.571rem;
}

.status-option {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 0.857rem;
  border-radius: 0.428rem;
  transition: all 0.2s;
}

.status-option:hover {
  background: #f8f8f8;
}

.status-option strong {
  color: #5e5873;
  font-weight: 600;
}

.status-option .text-muted {
  color: #b9b9c3;
  font-size: 0.857rem;
}

.status-icon {
  font-size: 1.714rem;
  line-height: 1;
  filter: grayscale(20%);
}
</style>

